import { configureStore } from '@reduxjs/toolkit';

import themeReducer from './slice/themeSlice';
import userReducer from './slice/userSlice';
import proxyReducer from './slice/proxySlice';
import ordersReducer from './slice/orderSlice';
import balanceReducer from './slice/balanceSlice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        user: userReducer,
        proxy: proxyReducer,
        orders: ordersReducer,
        balance: balanceReducer
    }
}); 